import { NavigationReady } from "@softmax/web-features/navigation/markers";
import s from "../onepager.module.css";

export function LeaderboardUnavailable({
  path,
  terminalFailure,
  onRetry,
  pending,
}: {
  readonly path: string;
  readonly terminalFailure: boolean;
  readonly onRetry: () => void;
  readonly pending: boolean;
}) {
  return (
    <output className={s.empty}>
      {terminalFailure ? (
        <NavigationReady stage="content" path={path} status="error" />
      ) : null}
      Leaderboard unavailable.{" "}
      <button
        type="button"
        data-cogent-safe
        className="underline underline-offset-2 disabled:opacity-60"
        disabled={pending}
        onClick={onRetry}
      >
        {pending ? "Trying again…" : "Try again"}
      </button>
    </output>
  );
}
